/* Open To Close: drop countdowns. Each [data-countdown] carries the drop time as typed in the theme editor
   (UK time, like 2026-11-20 18:00) plus Liquid's Unix time as a fallback; this ticks it every second. */
(() => {
  'use strict';
  const pad = n => String(n).padStart(2, '0');
  const LONDON = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  // "2026-11-20 18:00" means 18:00 on a UK clock, GMT in winter and BST in summer
  function ukTime(text) {
    const m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?\s*$/.exec(text || '');
    if (!m) return NaN;
    const guess = Date.UTC(+m[1], m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    const p = Object.fromEntries(LONDON.formatToParts(guess).map(x => [x.type, x.value]));
    const wall = Date.UTC(+p.year, p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    return guess - (wall - guess);
  }
  let timer = 0;
  function init() {
    clearInterval(timer);
    const live = [...document.querySelectorAll('[data-countdown]')]
      .map(el => ({ el, at: ukTime(el.dataset.countdownAt) || Number(el.dataset.countdown) * 1000, cells: Object.fromEntries([...el.querySelectorAll('[data-cd]')].map(c => [c.dataset.cd, c])) }))
      .filter(c => Number.isFinite(c.at) && c.at > 0);
    if (!live.length) return;
    const tick = () => {
      const now = Date.now();
      for (const c of live) {
        c.el.hidden = false;
        let s = Math.max(0, Math.floor((c.at - now) / 1000));
        if (!s) {
          // the drop is live: swap the clock for the "it's open" line
          c.el.classList.add('is-done');
          c.el.querySelector('[data-countdown-clock]').hidden = true;
          c.el.querySelector('[data-countdown-done]').hidden = false;
          c.done = true;
          continue;
        }
        const d = Math.floor(s / 86400); s -= d * 86400;
        const h = Math.floor(s / 3600); s -= h * 3600;
        const m = Math.floor(s / 60); s -= m * 60;
        c.cells.d.textContent = pad(d); c.cells.h.textContent = pad(h); c.cells.m.textContent = pad(m); c.cells.s.textContent = pad(s);
      }
      if (live.every(c => c.done)) clearInterval(timer);
    };
    tick();
    timer = setInterval(tick, 1000);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
